import { inject, Injectable } from '@angular/core';
import { ApiServiceBase } from '@twist/core';
import { firstValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import {
  CreateOrganizationMemberRoleCommand, CreateOrganizationMemberRoleCommandResult,
  DeleteOrganizationMemberRoleCommandResult,
  GetOrganizationMemberRolesQueryResult, OrganizationMemberRolesBackboneService,

  UpdateOrganizationMemberRoleCommand,
  UpdateOrganizationMemberRoleCommandResult
} from '@twist/backbone-api-services/ciam';

@Injectable({ providedIn: 'root' })
export class OrganizationMemberRolesService extends ApiServiceBase {
  private backboneService = inject(OrganizationMemberRolesBackboneService);


  getOrganizationMemberRoles = (organizationKey: string): Promise<GetOrganizationMemberRolesQueryResult> => {
    return new Promise<GetOrganizationMemberRolesQueryResult>((resolve, reject) => {
      firstValueFrom(
        this.backboneService.getOrganizationMemberRoles(
          organizationKey
        )
      )
        .then((result) => {
          resolve(result);
        })
        .catch(async (err: HttpErrorResponse | null) => {
          await this.handleErrorAndReject('', err, reject);
        });
    });
  };

  createOrganizationMemberRole = (
    organizationKey: string,
    command: CreateOrganizationMemberRoleCommand): Promise<CreateOrganizationMemberRoleCommandResult> => {
    return new Promise<CreateOrganizationMemberRoleCommandResult>((resolve, reject) => {
      firstValueFrom(
        this.backboneService.createOrganizationMemberRole(
          organizationKey, command
        )
      )
        .then((result) => {
          resolve(result);
        })
        .catch(async (err: HttpErrorResponse | null) => {
          await this.handleErrorAndReject('', err, reject);
        });
    });
  };

  updateOrganizationMemberRole = (
    organizationKey: string,
    roleKey: string,
    command: UpdateOrganizationMemberRoleCommand): Promise<UpdateOrganizationMemberRoleCommandResult> => {
    return new Promise<UpdateOrganizationMemberRoleCommandResult>((resolve, reject) => {
      firstValueFrom(
        this.backboneService.updateOrganizationMemberRole(
          organizationKey, roleKey, command
        )
      )
        .then((result) => {
          resolve(result);
        })
        .catch(async (err: HttpErrorResponse | null) => {
          await this.handleErrorAndReject('', err, reject);
        });
    });
  };

  deleteOrganizationMemberRole = (
    organizationKey: string,
    roleKey: string): Promise<DeleteOrganizationMemberRoleCommandResult> => {
    return new Promise<DeleteOrganizationMemberRoleCommandResult>((resolve, reject) => {
      firstValueFrom(
        this.backboneService.deleteOrganizationMemberRole(
          organizationKey, roleKey
        )
      )
        .then((result) => {
          resolve(result);
        })
        .catch(async (err: HttpErrorResponse | null) => {
          await this.handleErrorAndReject('', err, reject);
        });
    });
  };
}
